import { PropsWithChildren } from 'react'

import { ValueStyled } from '../result-value'

export const ResultValueText = ({ children }: PropsWithChildren<unknown>) => {
  return <ValueStyled>{children}</ValueStyled>
}
